module.exports = __webpack_public_path__ + "static/media/Sandra.d6a497af.jpeg";